export default {"src":"/_next/static/media/google-drive-icon.a4a92b36.svg","height":741,"width":800};